import axios from "axios";
import {appConfig} from "../config/defaultConfig";

const IROH_SERVICES = appConfig.APP.IROH_SERVICES;

export const whoami = () => axios.get(IROH_SERVICES.ROUTES.WHOAMI);

export const getAppLogins = async () => axios.get(IROH_SERVICES.ROUTES.LOGINS);

export const getTokenFromCode = (code) =>
  axios.post(IROH_SERVICES.ROUTES.CODE, {code});
